import { useEffect, useState } from "react";

export const useAttr = (name: string) => {
  const [value, setValue] = useState<string | null>(() => {
    try {
      return document.documentElement.getAttribute(name);
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes") {
          setValue(document.documentElement.getAttribute(name));
        }
      }
    });

    observer.observe(document.documentElement, {
      attributeFilter: [name],
    });

    return () => {
      observer.disconnect();
    };
  }, [name]);

  return value;
};
